var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginForm',{attrs:{"body-text":'Please enter in your new password',"fields":['password-create', 'go back'],"logo-url":'https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-02.svg',"submit-text":'Submit new password'},on:{"submitted":_vm.requestNew}})
}
var staticRenderFns = []

export { render, staticRenderFns }